import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import { Eye, EyeOff } from "lucide-react";


const AddStnApproval_edit = () => {
  useAuthRedirect();
    const {stnId} = useParams();
  const navigate = useNavigate();
  const [showLifeDetail, setShowLifeDetail] = useState(false);
const [formData, setFormData] = useState({
  
  });

      const canEdit = hasPermission("STN Requisition Approval", "edit");
    


  useEffect(() => {
     // Fetch Vehicle Position Data
  const fetchStnDetails = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/stn_edit/${stnId}`);
      if (response.data && response.data.position) {
        setFormData({
            stn_purnumber: response.data.position.stn_purnumber || "",
            stn_now: response.data.position.stn_now || "",
            stn_dpt: response.data.position.stn_dpt || "",
            stn_hod: response.data.position.stn_hod || "",
            stn_requbasis: response.data.position.stn_requbasis || "",
            stn_headmet: response.data.position.stn_headmet || "",
            stn_inref: response.data.position.stn_inref || "",
            stn_remarks: response.data.position.stn_remarks || "",
          stn_branch: response.data.position.stn_branch || "",
          stn_itemcode: response.data.position.stn_itemcode || "",
          stn_drawno: response.data.position.stn_drawno || "",
          stn_desc: response.data.position.stn_desc || "",
          stn_uom: response.data.position.stn_uom || "",
          stn_duedate: response.data.position.stn_duedate || "",
          stn_price: response.data.position.stn_price || "",
          stn_specification: response.data.position.stn_specification || "",
          stn_qty: response.data.position.stn_qty || "",
          stn_purpose: response.data.position.stn_purpose || "",
          stn_lifetime: response.data.position.stn_lifetime || "",

        });
      }
    } catch (error) {
      console.error("Error fetching vehicle position details:", error);
    }
  };
  fetchStnDetails()
  }, [stnId]);
  
   // Handle Input Change
   const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle Form Submit (Update Data)
  const handleSubmit = async (e) => {
  e.preventDefault();

 if (!formData.stn_qty || isNaN(formData.stn_qty)) {
  Swal.fire("Error", "Quantity must be a valid number.", "error");
  return;
}
if (Number(formData.stn_qty) <= 0) {
  Swal.fire("Error", "Quantity must be greater than 0.", "error");
  return;
}


  // ✅ Validate Due Date
  if (!formData.stn_duedate) {
    Swal.fire("Error", "Due date is required.", "error");
    return;
  }
  const today = new Date();
  const dueDate = new Date(formData.stn_duedate);
  today.setHours(0, 0, 0, 0); 
  if (dueDate < today) {
    Swal.fire("Error", "Due date cannot be in the past.", "error");
    return;
  }

  try {
            Swal.fire({
                        title: "Submitting...",
                        text: "Please wait while we process your request.",
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });
    const updatedData = {
      dueDate: formData.stn_duedate,
      qty: formData.stn_qty,
    };

    const response = await axios.put(
      `https://rfs2.infraconsoft.net.in/api/stnApproval_update/${stnId}`,
      updatedData
    );

    if (response.data.success) {
      Swal.fire({
        title: "Success!",
        text: "Stn updated successfully.",
        icon: "success",
        width: "500px",
        height: "40vh",
        draggable: true,
      }).then(() => {
        navigate(`/inventory/stn_approvalview`);
      });
    } else {
      Swal.fire("Error", "Failed to update vehicle position.", "error");
    }
  } catch (error) {
    console.error("Error updating vehicle position:", error);
    Swal.fire("Error", "An error occurred while updating the vehicle position.", "error");
  }
};

  
if (!canEdit) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
  <h2 className="add-txt">STN Requisition - Edit</h2>
  <Link to={`/inventory/viewstn_newapproval/${formData.stn_purnumber}`}>
    <p className="back-button">
      <i className="fa-solid fa-backward"></i> Back
    </p>
  </Link>
</div>

          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>STN Req No :</label>
                <input type="text" name="stn_purnumber" value={formData.stn_purnumber} readOnly/>

              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text"
                value={formData.stn_now ? new Date(formData.stn_now).toISOString().split("T")[0] : ""} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>To Branch :</label>
                <input type="text" name="type" value={formData.stn_branch} readOnly />
              </div>
              <div className="form-group">
                <label>Department :</label>
                <input type="text" name="branch" value={formData.stn_dpt} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" value={formData.stn_hod} readOnly/>
              </div>

              <div className="form-group">
                <label>Head Meterial:</label>
                <input type="text"value={formData.stn_headmet} readOnly />
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Req Basis :</label>
                <input type="text" value={formData.stn_requbasis} readOnly/>
              </div>

              <div className="form-group">
                <label>Indent Ref :</label>
                <input type="text" value={formData.stn_inref} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={formData.stn_remarks} readOnly/>
              </div>

              <div className="form-group">
                <label></label>
                <input type="hidden"/>
              </div>
            </div>
            
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Due Date</th>
                    <th>Specification</th>
                    <th>Purpose</th>
                    {showLifeDetail && (
                                              <th style={{ textAlign: "center" }}>
                                                Life Detail
                                              </th>
                                            )}
                                            <th>
                                              <button
                                                type="button"
                                                onClick={() => setShowLifeDetail(!showLifeDetail)}
                                                style={{
                                                  background: "none",
                                                  border: "none",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
                                              </button>
                                            </th>
                  </tr>
                </thead>
                <tbody>
                  
                      <tr>
                        <td>{formData.stn_itemcode}</td>
                        <td>{formData.stn_drawno}</td>
                        <td>{formData.stn_desc}</td>
                        <td>{formData.stn_uom}</td>
                        <td>{formData.stn_price}</td>
                        <td><input type="number" name="stn_qty" value={formData.stn_qty}  onChange={handleInputChange}/></td>
                        <td>  <input type="date" name="stn_duedate" value={formData.stn_duedate ? new Date(formData.stn_duedate).toISOString().split('T')[0] : ''} onChange={handleInputChange}  required /></td>
                        <td>{formData.stn_specification}</td>
                        <td>{formData.stn_purpose}</td>
                                    {showLifeDetail && (
 <td>{formData.stn_lifetime}</td>
                )}
                        
                      </tr>
                </tbody>
              </table>
            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default AddStnApproval_edit;
